/**
 * Servicio que devuelve la class FbTemplateCellEditor para que el grid la instancie cuando se empieza a editar una celda.
 *
 * Esta clase esta medio vacia, solo sirve para encapsular los campos tipo el input, que son de cabecera, para que se pintan en el grid.
 *
 * @param {Class} FbCellEditor La clase base que se inyecta para dependency injection
 * @param {Object} options Opciones que se pasaran al FbCellEditor
 * @param {Object} methods Lista de metodos especificos
 * @param {function} methods.render metodo que llama el grid para pintar el html de la celda
 * @returns {Class}
 */

const defaultOptions = { ecCellName: 'FbTemplateCellEditor' };

export default function FbTemplateCellEditorClass(FbCellEditor, options = {}, { render } = {}) {
  return class FbTemplateCellEditor extends FbCellEditor {
    constructor() {
      super(Object.assign({}, defaultOptions, options));

      this.render = render.bind(this);
    }
  };
}
